module.exports = __webpack_public_path__ + "img/lunbo154.51f72ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo154.png
// module id = T2y9
// module chunks = 0